jQuery(document).ready(function($) {
    // Don't run if there's no search-input-field (= not on studios-page)
    if (!$('#cle-studio-search-form').length) {
        return;
    }
    console.log('Studio-search JS-script active!');

    const getUrlParameter = (sParam) => {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    const findStudios = (searchQuery) => {
        console.log(searchQuery);
        $('.studio-select').addClass('loading');
        let currentPage = isContractPage ? 'contract-termination' : 'studios';

        $.ajax({
            type: 'GET',
            dataType: 'json',
            url: ajaxUrl,
            data: {
                action: 'find_studios',
                searchQuery: searchQuery,
                page: currentPage,
            },
            success: (data) => {
                console.log('works');
                console.log(data);
                $('.studio-select').html(data);
                $('.studio-select').removeClass('loading');
            },
            error: (error) => {
                console.log('works not');
                console.log(error);
                $('.studio-select').removeClass('loading');
            }
        });
    }

    // Trigger findStudios if studio-search-query is set
    if (getUrlParameter('studio-search-query')) {
        $('#studio-query-input').val(getUrlParameter('studio-search-query'));
        findStudios(getUrlParameter('studio-search-query'));
    }

    // Trigger findStudios on form-submit (& prevent page reload)
    $(document).on('submit','form#cle-studio-search-form',function(event){
        event.preventDefault();
        findStudios($('#studio-query-input').val());
    });

});
